import React, { useEffect, useState } from "react";
import { DtrfForm } from "b2c6a1a8wq-ak/dist";
import Head from "next/head";
import config from "../../config";
import { useHistory } from "react-router-dom";
import "./dtrf_css.css";
import Cookies from 'js-cookie';
import axios from 'axios'
import { getDoctorToken } from "../../utils";
const DtrfMobile = (props) => {
  const history = useHistory();
  const [doctorDetails ,setDoctorDetails] = useState("")
  const [doctorToken , setDoctorToken] = useState(false)
  const pushTo = (path) => {
    // console.log()
    history.push("/dtrfs");
  };
  // useEffect(()=>{
  //   if(!doctorDetails){
  //       if(Cookies.get("LilacDoctor")){
  //         setDoctorDetails(JSON.parse(Cookies.get("LilacDoctor")))
  //       }
  //   }
  // },[Cookies.get("LilacDoctor")])
  useEffect(()=>{
    
    if(!doctorToken){
      const token = Cookies.get("LilacDoctorToken")
      if(token){
        console.log("Token")
        localStorage.setItem("LilacDoctorToken",token)
        const response =  axios({
          url: `${config.api.base_url}doctor/get-detail`,
          method: "get",
          headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
              "accessToken":token
          }
        })
        response.then((res)=>{
          setDoctorToken(true)
          setDoctorDetails(res.data.data.result)
        })
      }else{
        const token = getDoctorToken()
        if(token){

          const response =  axios({
            url: `${config.api.base_url}doctor/get-detail`,
            method: "get",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${getDoctorToken()}`,
            }
          })
          response.then((res)=>{
            console.log(res)
            setDoctorToken(true)
            setDoctorDetails(res.data.data.result)
          })
        }
        }
    }
  },[Cookies.get("LilacDoctorToken")])
  return (
    <>
      <Head>
        <script src="../../js/app.min.js"></script>
        <script src="bundles/prism/prism.js"></script>
        <script src="bundles/jquery-pwstrength/jquery.pwstrength.min.js"></script>
        <script src="bundles/bootstrap-daterangepicker/daterangepicker.js"></script>
        <script src="bundles/bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min.js"></script>
        <script src="bundles/bootstrap-timepicker/js/bootstrap-timepicker.min.js"></script>
        <script src="bundles/bootstrap-tagsinput/dist/bootstrap-tagsinput.min.js"></script>
        <link
          rel="stylesheet"
          href="bundles/select2/dist/css/select2.min.css"
        />
        <script src="bundles/select2/dist/js/select2.full.min.js"></script>
        <script src="bundles/jquery-selectric/jquery.selectric.min.js"></script>
        <script src="../../js/scripts.js"></script>
        <script src="../../js/custom.js"></script>
      </Head>
      {doctorDetails && doctorToken ? (
        <DtrfForm
          fromDoctorDtrf={true}
          doctor_info={{
            doctorName:
            doctorDetails 
                ? {
                    _id: doctorDetails._id,
                    fname: doctorDetails.fname,
                    lname: doctorDetails.lname,
                    nt_status_for_reporting:
                      doctorDetails.nt_status_for_reporting,
                    value: doctorDetails._id,
                  }
                : {},
          }}
          institute_list={
            doctorDetails 
              ? doctorDetails.hospital
              : []
          }
          url={config.dtrf}
          pushTo={pushTo}
        ></DtrfForm>
      ) : (
        <h2>Loading Dtrf form</h2>
      )}
    </>
  );
};

export default DtrfMobile;
